export const THEME_VERSION = 64;
export const FORM_VALIDATION_MODE = "onTouched";

// Generic support mailbox: when it is the only email available, users are
// redirected to the Freshdesk form instead of a mailto link
export const MSPRO_SUPPORT_EMAIL = "mspro@ekwateur.fr";

// Writing IS_TEST_ENV this way is necessary to make tree shaking effective
export const IS_TEST_ENV =
  import.meta.env.MODE === "dev" || import.meta.env.MODE === "qual";

export const CLOSING_TARIFF_SHIELD_FORM_DATE = new Date("2024-3-31");
export const IS_TARIFF_FORM_COMPLETION_DISABLED =
  new Date() > CLOSING_TARIFF_SHIELD_FORM_DATE;

export const LANGUAGES = ["fr", "en"] as const;

export const LS_KEYS = {
  ACCESS_TOKEN: "accessToken",
  CAMELEON_EMAIL: "cameleonEmail",
  CAMELEON_FULL_NAME: "cameleonFullName",
  CURRENT_GROUP_REF: "currentGroupRef",
  EMAIL: "email",
  HIDE_EDIT_BUTTON: "hideEditButton",
  HIGHLIGHT_MODIFICATIONS: "highlightModifications",
  LANGUAGE: "i18nextLng",
  MENU_COLLAPSED: "menuCollapsed",
  MSW: "USE_MSW",
  REFRESH_TOKEN: "refreshToken",
  TENANT: "tenant",
  THEME_NAME: "themeName",
  THEME_VARIANT: "themeVariant",
};

export const DOCUMENT_NAME_VALUES = {
  CONTRACT: "CONTRACT",
  BUDGETARY_ANNEX: "BUDGETARY_ANNEX",
  TERMS_CONDITIONS: "TERMS_CONDITIONS",
  DATA_COLLECTION_AUTHORIZATION: "DATA_COLLECTION_AUTHORIZATION",
  METERS_ANNEX: "METERS_ANNEX",
  CONSUMPTION_RECORD: "CONSUMPTION_RECORD",
  BILLING_RECORD: "BILLING_RECORD",
  TACIT_RENEWAL_ELEC_2026: "TACIT_RENEWAL_ELEC_2026",
  TACIT_RENEWAL_GAS_2026: "TACIT_RENEWAL_GAS_2026",
  OTHER: "OTHER",
} as const;
